import type { CustomRole, CustomRoleColor } from '@nexo/types';
import { cn } from '@nexo/ui';

/** Dot + soft chip colours per custom role colour (readable in light and dark). */
export const roleColors: Record<CustomRoleColor, { dot: string; chip: string; text: string }> = {
  slate: {
    dot: 'bg-slate-500',
    chip: 'bg-slate-500/15 text-slate-700 dark:text-slate-300',
    text: 'text-slate-600 dark:text-slate-400',
  },
  red: {
    dot: 'bg-red-500',
    chip: 'bg-red-500/15 text-red-700 dark:text-red-300',
    text: 'text-red-600 dark:text-red-400',
  },
  orange: {
    dot: 'bg-orange-500',
    chip: 'bg-orange-500/15 text-orange-700 dark:text-orange-300',
    text: 'text-orange-600 dark:text-orange-400',
  },
  amber: {
    dot: 'bg-amber-500',
    chip: 'bg-amber-500/15 text-amber-700 dark:text-amber-300',
    text: 'text-amber-600 dark:text-amber-400',
  },
  green: {
    dot: 'bg-green-500',
    chip: 'bg-green-500/15 text-green-700 dark:text-green-300',
    text: 'text-green-600 dark:text-green-400',
  },
  teal: {
    dot: 'bg-teal-500',
    chip: 'bg-teal-500/15 text-teal-700 dark:text-teal-300',
    text: 'text-teal-600 dark:text-teal-400',
  },
  sky: {
    dot: 'bg-sky-500',
    chip: 'bg-sky-500/15 text-sky-700 dark:text-sky-300',
    text: 'text-sky-600 dark:text-sky-400',
  },
  indigo: {
    dot: 'bg-indigo-500',
    chip: 'bg-indigo-500/15 text-indigo-700 dark:text-indigo-300',
    text: 'text-indigo-600 dark:text-indigo-400',
  },
  violet: {
    dot: 'bg-violet-500',
    chip: 'bg-violet-500/15 text-violet-700 dark:text-violet-300',
    text: 'text-violet-600 dark:text-violet-400',
  },
  pink: {
    dot: 'bg-pink-500',
    chip: 'bg-pink-500/15 text-pink-700 dark:text-pink-300',
    text: 'text-pink-600 dark:text-pink-400',
  },
};

export const permissionLabel = { owner: 'Propietario', admin: 'Admin', member: 'Miembro' } as const;

export function RoleChip({ role, className }: { role: CustomRole; className?: string }) {
  return (
    <span
      className={cn(
        'inline-flex max-w-full items-center gap-1 rounded-full px-2 py-0.5 text-[11px] font-medium',
        roleColors[role.color].chip,
        className,
      )}
    >
      <span className={cn('size-1.5 shrink-0 rounded-full', roleColors[role.color].dot)} />
      <span className="truncate">{role.name}</span>
    </span>
  );
}
